import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import CompactCBSAnalytics from './CompactCBSAnalytics'
import AnalyticsDashboard from './AnalyticsDashboard'

// Update the PropertyAnalyticsSection component to use our new compact CBS Analytics
const NeighborhoodAnalyticsSection = ({ listing, userToken }) => {
  const [fullAnalyticsOpen, setFullAnalyticsOpen] = useState(false)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const handleViewMore = () => {
    setFullAnalyticsOpen(true)
  }

  const handleClose = () => {
    setFullAnalyticsOpen(false)
  }

  return (
    <>
      {/* Compact analytics view embedded in the listing page */}
      <CompactCBSAnalytics
        address={`${listing.address} ${listing.postcode}, ${listing.city}`}
        listingCity={listing.city}
        onViewMore={handleViewMore}
      />

      {/* Full analytics view in modal dialog */}
      <Dialog
        open={fullAnalyticsOpen}
        onClose={handleClose}
        fullScreen={fullScreen}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
          }}
        >
          Neighborhood Analytics
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <AnalyticsDashboard
            address={listing.address}
            postcode={listing.postcode}
            city={listing.city}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default NeighborhoodAnalyticsSection
